import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useFeatures() {
  const [f, setF] = useState(null);
  useEffect(() => {
    cache = cache || api.get("/features").then(({ data }) => data).catch(() => ({}));
    cache.then(setF);
  }, []);
  return f;
}
